import { render, staticRenderFns } from "./JDSpecification.vue?vue&type=template&id=7d885296&scoped=true"
import script from "./JDSpecification.vue?vue&type=script&lang=js"
export * from "./JDSpecification.vue?vue&type=script&lang=js"
import style0 from "./JDSpecification.vue?vue&type=style&index=0&id=7d885296&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d885296",
  null
  
)

export default component.exports